export default {
    en: {
        LP: {
            // 言語切り替えボタン
            change_locale: '日本語',

            // OGP用情報
            ogp: {
                title: '',
                description: '',
                type: 'website',
                url: '',
                site_name: '',
                image: '/Images/Ogp/OGP.jpg',
                twitter_card: 'summary_large_image'
            },

            // INTRO
            intro: {
                headering: '2021.10.16 - 2022.4.10',
                h_caption: ' * The event date and time possible to be changing according to the Tokyo Mega Illumination program. ',
                url: 'https://www.tokyomegaillumi.jp/',
                lead_sp: '"NAKED BIG BOOK" will be ' +
                    '\r\n' +
                    'exhibited during TOKYO MEGA ILLUMINATION ' +
                    '\r\n' +
                    'program at The Ooi Horse Racecourse' +
                    '\r\n' +
                    '(Tokyo City KEIBA)',
                lead_pc: '"NAKED BIG BOOK" will be exhibited during TOKYO MEGA ILLUMINATION program at The Ooi Horse Racecourse(Tokyo City KEIBA)',
                hashtag: [{
                        tag: '#TCK',
                    },
                    {
                        tag: '#nakedinc',
                    },
                ],
            },

            //新型コロナウイルス感染症対策について
            covid19: {
                title: 'About infectious disease measures',
                notice: '1日の入場者数に制限がございます',
                caption: '人数制限のため、チケットの販売枚数を制限しています。' +
                    '\r\n' +
                    '前売りチケットのご購入をおすすめいたします。',
                detail: '詳細はこちら',
                spec: '以下の条件に当てはまる方はご来場をお断りしております。',
            },
            covid19_guide1: [{
                    thumbnail: './Images/covid/corona_pic_01_black.svg',
                    description: '入場時の検温で37.5℃以上の発熱がある方',
                },
                {
                    thumbnail: './Images/covid/corona_pic_02_black.svg',
                    description: '発熱・倦怠感など、体調がすぐれない方',
                },

            ],
            covid19_guide2: [{
                    thumbnail: './Images/covid/corona_pic_06_black.svg',
                    description: 'ご来場の際はマスクの着用をし、咳エチケットにご協力ください。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_05_black.svg',
                    description: '入場時、消毒液で手指の消毒をお願いします。入場後にもアルコール除菌アートを設置しております。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_03_black.svg',
                    description: '場内でのソーシャルディスタンスの確保をお願いします。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_04_black.svg',
                    description: 'マスクを外される際は、なるべく他の人との距離を保ち、大声での会話はご遠慮ください。',
                },
            ],

            //推奨環境について
            spec: {
                title: 'Recommended environment',
                browser: {
                    title: ' <OS / Browser>',
                    text: 
                        ' iOS safari / Chrome iOS12 or higher (Settings-> Safari-> Details-> Experimental Features-> Webgl2 must be turned on.)' +
                        '\r\n' +
                        'Android 5.0 or higher Chrome 90 or higher' +
                        '\r\n' +
                        ' Android 5.0 or higher Android Browser (standard installed browser) 92 or higher' +
                        '\r\n' +
                        'Samsung Internet (browser installed as standard on Samsung products such as Garaxy) 7.2 or higher' +
                        '\r\n' +
                        ' * We recommend updating each browser to the latest version.',
                },
                function: {
                    title: ' <Terminal required functions>',
                    text: 'GPS, acceleration and compass are required.' +
                        '\r\n' +
                        'Please note that the wifi version of the iPad does not have GPS.' +
                        '\r\n' +
                        ' * In addition, due to various conditions of the terminal, operation is not guaranteed for all models even under the above conditions.',
                },
            },

            //BIG BOOK
            big_book: {
                renewal: 'Renewed',
                renewal_caption: 'Since its birth in October 2018, "TWIN KURUKURU FANTASY" has been familiar to many people. The costume has also been renewed. As a new welcome area, we are looking forward to collaborating with creative company NAKED, INC. as a memorable place for more people in the future.',
                story: 'Direction / Story',
                story_caption: 'White horse, who jumped out of BIG BOOK, will guide you through the world of Mega Illumination while using light. White horse is very friendly. Please play a lot with Mega Illumination and get to know each other.',
            },

            // CONTENTS
            contents: {
                summary: 'ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。',
                more: 'Read more',
                close: 'Close',
            },
            contents_in: [{
                    image: './Images/contents/megaillumi_pers_BB.jpg',
                    title: '',
                    title_sub: '',
                    caption: 'White horse runs around in a big book! You can enjoy the world of Mega Illumination as if it had popped out of the book. There is also a mechanism using AR, so please enjoy it. "NAKED BIG BOOK" is a representative work of NAKED INC. who applies projection mapping to a huge book object and invites you to the world of the story every time the page is turned.',
                },
                {
                    image: './Images/contents/megaillumi_pers_logo.jpg',
                    title: '',
                    title_sub: '',
                    caption: 'The letters of " "TOKYO CITY KEIBA" shine colorfully and are surrounded by illuminations. In conjunction with the "NAKED BIG BOOK" video, the world view of the video is expanded into space. "',
                },
                {
                    image: './Images/contents/megaillumi_pers_int.jpg',
                    title: '',
                    title_sub: '',
                    caption: "[Interactive]Let's play with white horse who jumped out of 'NAKED BIG BOOK'! When you walk or run, your footprints turn into hooves.",
                },
            ],
            contents_ar_in: [{
                    image: './Images/contents/megaillumi_pers_AR.jpg',
                    title: '',
                    title_sub: '',
                    caption: 'Meet white horse using your smartphone AR. White horse, who jumped out of the NAKED BIG BOOK because of the fun, runs with more power than ever!',
                },
                /* {
                    image: './Images/contents/megaillumi_pers_shibahu.jpg',
                    title: '',
                    title_sub: '',
                    caption: '"Introducing an AR filter that allows you to enjoy the experience of Mega Illumination anytime, anywhere! Take a lot and share it ♪' +
                        '\r\n' +
                        'Recommended place: Big Tree playing with light / Lawn Square "',
                }, */
            ],

            // PRICE
            price: {
                title: 'Admission Free',
                caption: '※You can enjoy it only with the admission fee of Tokyo Mega Illumination',
                banner: './Images/banner/2021_ooimegaillumi_tgi_banner_pc@2x.png',
            },

            //CREDIT
            credit: {
                organizer: 'The Host Organization',
                organizer_caption: 'TOKYOTOKEIBA CO.,Ltd.' +
                    '\r\n' +
                    'TOKYO METROPOLITAN RACING ASSOCIATION',
                support: 'Special Thanks',
                project: 'Produced by',
                caption: 'NAKED, INC. is a Tokyo based creative company Ryotaro Muramatsu founded in 1997 along with a team of directors, designers, and writers. Pursuing the philosophy of "Core Creative", "Total Creation" and "Borderless Creativity", the company has presented works throughout the years in film, television, music videos, advertisements, spatial presentation, local community revitalization, and education programs. In recent years, NAKED, INC. has developed a number of projection mapping spectacles and immersive exhibitions such as FLOWERS BY NAKED and TOKYO ART CITY BY NAKED. "TREE by NAKED yoyogi park", an interactive restaurant combining cuisine and art opened in Tokyo in 2017. NAKED, INC. continues to create new experiences and values throughout various scenes in people’s lives, spanning from art and entertainment to culture, tradition, education, music, cities, food, and sports.',
            },

            buy_tickets: 'Buy Tickets',

        }
    }
}